import SecureLS from 'secure-ls';
import { loggerError } from './Log';
import { TRANSLATION_DATA_KEY, CENTRAL_PROFILE_KEY, AUTH0_RESULT_KEY, DEVELOPMENT_MODE, } from '../constants/constants';
export var storageKey = window.navigator.userAgent.replace(/\D+/g, '');
export var getCacheStorage = function () { return window.caches; };
var instance;
export var getInstance = function () {
    if (!instance) {
        instance = new SecureLS();
    }
    return instance;
};
var ttlKey = function (key) { return "".concat(key, "-expiration"); };
export var removeKey = function (key) {
    var c = getInstance();
    c.remove(key);
    c.remove(ttlKey(key));
};
var getCacheItem = function (key, allModes) {
    if (allModes === void 0) { allModes = false; }
    try {
        if (allModes || DEVELOPMENT_MODE) {
            var c = getInstance();
            var ttl = c.get(ttlKey(key));
            if (!ttl || ttl < Date.now()) {
                return undefined;
            }
            var data = c.get(key);
            if (data) {
                return JSON.parse(data);
            }
        }
    }
    catch (error) {
        loggerError("error get ".concat(key), error);
    }
    return undefined;
};
var setCacheItem = function (key, data, ttl) {
    if (ttl === void 0) { ttl = 3600; }
    try {
        var c = getInstance();
        c.set(key, data);
        c.set(ttlKey(key), Date.now() + (ttl * 1000));
    }
    catch (error) {
        loggerError("error set ".concat(key), error);
    }
};
export var clearCacheInstance = function () {
    try {
        removeKey(CENTRAL_PROFILE_KEY);
        removeKey(TRANSLATION_DATA_KEY);
    }
    catch (error) {
        loggerError('error clearCacheInstance', error);
    }
};
export var setCacheTranslation = function (data) {
    setCacheItem(TRANSLATION_DATA_KEY, data);
};
export var getCacheTranslation = function () { return getCacheItem(TRANSLATION_DATA_KEY); };
export var clearCacheTranslation = function () {
    try {
        removeKey(TRANSLATION_DATA_KEY);
    }
    catch (error) {
        loggerError('error clearCacheTranslation', error);
    }
};
export var setCacheProfile = function (data) {
    setCacheItem(CENTRAL_PROFILE_KEY, data);
};
export var getCacheProfile = function () { return getCacheItem(CENTRAL_PROFILE_KEY); };
export var setCacheAuth0Result = function (data, ttl) {
    setCacheItem(AUTH0_RESULT_KEY, data, ttl);
};
export var getCacheAuth0Result = function () { return getCacheItem(AUTH0_RESULT_KEY, true); };
export var clearCacheAuth0Result = function () {
    try {
        removeKey(AUTH0_RESULT_KEY);
    }
    catch (error) {
        loggerError('error clearCacheAuthResult', error);
    }
};
//# sourceMappingURL=secureCache.js.map